<template>
  <div class="container">
    <div class="bgoverlay">
      <div class="bg" :style="{'background-image': `url(${require('@/assets/images/industriesbg7.jpg')})`}"></div>
    </div>
    <div class="inner-pannel">
      <div class="pannel-content">
        <div class="pannel-content-box maxwidth-lg topPoint">
          <div style="height:55px;"></div>
          <div class="content-page">
            <div class="ani animate__animated animate__fadeInUp">
              <div :class="$i18n.locale=='zh'?'zh-font':'en-font'">{{$t('chemicalReagent.content1')}}</div>
              <div style="height:20px;"></div>
              <span class="jiantou" @click="show">{{ showHidden?$t('index.about.hideMore'):$t('index.about.more')}}<i :class="showHidden?'el-icon-arrow-up':'el-icon-arrow-down'"></i></span>
            </div>
            <div class="hiddenBox ani animate__animated animate__fadeInDown" v-if="showHidden">
              <div style="height:20px;"></div>
              <img style="width:50%" src="../../assets/images/industries12.jpg">
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default({
  data() {
    return{
      showHidden:false
    }
  },
  methods:{
    show() {
      this.showHidden = !this.showHidden
    }
  }
})
</script>

<style scoped>
    .topPoint::after {
        width: 25px;
        height: 25px;
        content: "";
        position: absolute;
        background: #ed6d00;
        border-radius: 50%;
        z-index: 1;
        top: -12.5px;
        right: -12.5px;
    }
    .title-text{
        color: #ED6D00;
    }
    .inner-pannel{
        min-height: 100%;
        padding-bottom: 54px;
        position: static;
        /* position: relative; */
        /* position: absolute; */
        width: 100%;
        font-family: "Lato";
    }
    .flex{
      display: flex;
      flex-wrap: wrap;
      justify-content: space-between;
    }
    .flex img{
      width: 25%;
    }
    .left{
      width: calc(75% - 20px);
    }
  .jiantou{
    font-family: 'Lato','Microsoft JhengHei';
    color: #ffffff!important;
    /* position: absolute; */
    /* right: 0; */
    cursor:pointer;
  }
  .el-icon-arrow-down::before {
    color: #ffffff!important;
  }
  .el-icon-arrow-up::before{
      color: #ffffff!important;
  }
  .hiddenBox{
    height: auto;
  }
    @media screen and (max-width:768px) {
      .left{
        width: 100%;
      }
      .right{
        margin-top: 20px;
        width: 100%;
      }
      .flex img {
        margin-top: 10px;
        width: 100%;
      }
  }
</style>



// WEBPACK FOOTER //
// src/components/chemicalReagent/chemicalReagent.vue